import Appraisal from './Appraisal';
import AppraisalOffice from './AppraisalOffice';
import Formalization from './Formalization';
import FormalizationOffice from './FormalizationOffice';

const AppraisalWidget = ({
	dataMortgage,
	operationId,
	stages,
	existAppraisal,
	getAppraisal,
	handleChangeCollapse,
	docsNumber
}) => {
	return (
		<div>
			{stages === 'appraisal' && process.env.REACT_APP_BRAND === 'web' && (
				<>
					<Appraisal
						stages={stages}
						dataMortgage={dataMortgage}
						operationId={operationId}
						existAppraisal={existAppraisal}
						getAppraisal={getAppraisal}
					/>
				</>
			)}
			{stages === 'appraisal' && process.env.REACT_APP_BRAND === 'office' && (
				<>
					<AppraisalOffice
						stages={stages}
						dataMortgage={dataMortgage}
						operationId={operationId}
						existAppraisal={existAppraisal}
						getAppraisal={getAppraisal}
					/>
				</>
			)}
			{stages === 'formalization' && process.env.REACT_APP_BRAND === 'web' && (
				<Formalization
					stages={stages}
					dataMortgage={dataMortgage}
					operationId={operationId}
					existAppraisal={existAppraisal}
				/>
			)}
			{stages === 'formalization' && process.env.REACT_APP_BRAND === 'office' && (
				<FormalizationOffice
					handleChangeCollapse={handleChangeCollapse}
					stages={stages}
					dataMortgage={dataMortgage}
					operationId={operationId}
					existAppraisal={existAppraisal}
					docsNumber={docsNumber}
				/>
			)}
		</div>
	);
};

export default AppraisalWidget;
